class CartDrawerRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      event.preventDefault();
      this.closest('cart-drawer').updateQuantity(this.dataset.index, 0);
    });
  }
}

customElements.define('cart-drawer-remove-button', CartDrawerRemoveButton);

class CartDrawer extends HTMLElement {
  constructor() {
    super();

    console.log("element added");

    // Elements
    this.drawer = document.getElementById('cart-drawer');

    this.cartButton = document.querySelector('.js-open-cart');
    this.cartButton?.addEventListener('click', this.handleCartClick.bind(this));

    this.closeIcon = document.getElementById('cart-drawer__close');
    this.closeIcon.addEventListener('click', this.close.bind(this));

    this.onBodyClick = this.handleBodyClick.bind(this);
    this.drawer.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());

    this.pageOverlayElement = document.querySelector('.page-overlay');

    // Functionality
    this.currentItemCount = Array.from(this.querySelectorAll('[name="updates[]"]')).reduce(
      (total, quantityInput) => total + parseInt(quantityInput.value),
      0
    );

    this.content = document.getElementById('cart-drawer__content');
    this.itemCount = document.getElementById('cart-item-count');
    this.requestId = 0;
    this.pendingChanges = 0;
    this.needsRefresh = false;
    this.contentObserver = new MutationObserver(this.onContentChange.bind(this));
    this.contentObserver.observe(this.content, { childList: true });

    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);

    this.addEventListener('change', this.debouncedOnChange.bind(this));
  }

  open() {
    this.drawer.setAttribute('aria-hidden', false);
    this.drawer.setAttribute('aria-expanded', true);

    this.pageOverlayElement.classList.add('is-visible');
    document.body.addEventListener('click', this.onBodyClick);

    document.body.classList.add('scroll-lock');
    this.onUpdateSplides();
    this.refresh();
  }

  close() {
    this.drawer.setAttribute('aria-hidden', true);
    this.drawer.removeAttribute('aria-expanded', true);

    this.pageOverlayElement.classList.remove('is-visible');
    document.body.removeEventListener('click', this.onBodyClick);

    document.body.classList.remove('scroll-lock');
  }

  onContentChange() {
    if (this.pendingChanges > 0) this.needsRefresh = true;
    this.syncItemCount();
  }

  syncItemCount() {
    const source = this.content.querySelector('[data-cart-count]');
    if (!source || !this.itemCount) return;

    this.itemCount.textContent = `(${source.dataset.cartCount})`;
  }

  onChange(event) {
    this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'));
  }

  onUpdateSplides() {
    setTimeout(() => {
      const reviews = document.querySelector('.cart-drawer-reviews-splide');
      if (reviews) {
        new Splide(reviews, {
          type: 'loop',
          perPage: 3,
          perMove: 1,
          gap: '1.25em',
          pagination: false,
          autoplay: true,
          arrows: false,
          pagination: true,
          focus: 'center',
        }).mount();
      }
    }, 500);
  }

  updateQuantity(line, quantity, name) {
    this.enableLoading(line);

    const requestId = ++this.requestId;
    this.pendingChanges++;

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        if (requestId !== this.requestId) return;

        if (this.needsRefresh) {
          this.refresh();
          return;
        }

        const parsedState = JSON.parse(state);

        this.renderSections(parsedState.sections);
        this.updateUpsells(parsedState);
      })
      .catch(() => {
        if (requestId === this.requestId) this.refresh();
      })
      .finally(() => {
        this.pendingChanges--;
        if (requestId === this.requestId) this.disableLoading();
      });
  }

  refresh() {
    const requestId = ++this.requestId;
    this.needsRefresh = false;

    const sections = [...new Set(this.getSections().map((section) => section.section))];

    fetch(`${window.location.pathname}?sections=${sections.join(',')}`)
      .then((response) => response.json())
      .then((sectionsHtml) => {
        if (requestId !== this.requestId) return;

        const html = sectionsHtml[this.content.dataset.id];
        if (!html || this.getCartState(this.parseHTML(html)) === this.getCartState(this.content)) return;

        this.renderSections(sectionsHtml);
      })
      .catch(() => {});
  }

  renderSections(sectionsHtml) {
    this.getSections().forEach((section) => {
      const html = sectionsHtml[section.section];
      const container = document.getElementById(section.id);
      if (!html || !container) return;

      const source = this.parseHTML(html).querySelector(section.selector);
      if (!source) return;

      const elementToReplace = container.querySelector(section.selector) || container;
      elementToReplace.innerHTML = source.innerHTML;
    });

    this.contentObserver.takeRecords();
    this.syncItemCount();
    this.onUpdateSplides();
  }

  getCartState(root) {
    return root.querySelector('[data-cart-state]')?.dataset.cartState;
  }

  getSectionsToRender() {
    this.onUpdateSplides();
    return this.getSections();
  }

  getSections() {
    return [
      {
        id: 'cart-drawer__content',
        section: this.content.dataset.id,
        selector: '.cart-drawer__content',
      },
      {
        id: 'cart-icon-bubble',
        section: 'header',
        selector: '.js-open-cart',
      },
      {
        id: 'cart-item-count',
        section: 'cart-drawer',
        selector: '#cart-item-count',
      },
    ];
  }

  parseHTML(html) {
    return new DOMParser().parseFromString(html, 'text/html');
  }

  enableLoading() {
    document.getElementById('cart-drawer-loading')?.classList.remove('hidden');
  }

  disableLoading() {
    document.getElementById('cart-drawer-loading')?.classList.add('hidden');
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target.classList.contains('page-overlay')) {
      this.close();
      this.pageOverlayElement.classList.remove('is-visible');
    }
  }

  handleCartClick(evt) {
    evt.preventDefault();
    this.open();
  }

  updateUpsells(cart) {
    const upsellPrices = document.querySelectorAll('.product-upsell__button .price');
    let itemCount = 0;

    for (let item of cart.items) {
      if (item.product_type == 'The Elixir Mixer') {
        itemCount = itemCount + item.quantity;
      }
    }

    if (itemCount >= 2) {
      upsellPrices.forEach((price) => (price.innerHTML = '$52.80 each'));
    } else {
      upsellPrices.forEach((price) => (price.innerHTML = '$66 each'));
    }
  }
}

customElements.define('cart-drawer', CartDrawer);
